import { useSkuBasesProductActivityData } from '../../../Contexts/UserSpecificProductDataStore/UserSpecificProductDataStore'
import Area from '../../../Molecules/Area'
import styles from './ProductActivityInfo.module.scss'

import React from 'react'

import Svg from 'Atoms/Svg'
import Typography from 'Atoms/Typography'

const ProductActivity = ({ skuBaseNumber, className }) => {
  const productActivity = useSkuBasesProductActivityData(skuBaseNumber)

  if (!productActivity) {
    return false
  }

  if (!productActivity.value.orderCountDisplayText || productActivity.value.orderCountDisplayText === '') {
    return false
  }

  return (
    <div className={styles.productActivity}>
      <Area
        title="Product Activity"
        brand={productActivity.value.calloutColor}
        noBorder={true}
        noPadding={true}
        className={styles.productActivityArea}
      >
        <div className={styles.productActivityContent}>
          <Svg brand={'primary'} icon={'cart'} size={0.75} tone={'normal'} className={styles.cartIcon} />
          <Typography size={0.75}>{productActivity.value.mobileDisplayText}</Typography>
        </div>
      </Area>
    </div>
  )
}

export default ProductActivity
